import IconButton from '@material-ui/core/IconButton';
import withStyles from '@material-ui/core/styles/withStyles';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const componentConfig = {
  name: 'MuiOriBorderedIconButton'
};
const styles = {
  root: {
    border: '1px solid currentColor'
  }
};
export const BorderedIconButton = props => /*#__PURE__*/_jsx(IconButton, { ...props
});
export default withStyles(styles, componentConfig)(BorderedIconButton);